import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Box, Container, Grid } from "@mui/material";
import "./MovieCardCss.css";
import axios from "axios";
import "./MovieCardCss.css";
import Modal from "@mui/material/Modal";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import YouTube from "react-youtube";

const myKey = "850c76a64839953d0d1631f4e46d66b8";
const API_URL = "https://api.themoviedb.org/3/movie";

export default function MovieCard({
  movieTitle,
  movieOverview,
  backgroundImg,
  posterImg,
  releaseDate,
  movieId,
}) {
  const [trailerKey, setTrailerKey] = React.useState();
  const [movieVideo, setMovieVideos] = React.useState(null);

  const [open, setOpen] = React.useState(false);
  const handleOpen = async () => {
    setOpen(true)
    await fetchMovieVideos()
  }
  const handleClose = () => setOpen(false);

  const fetchMovieVideos = async () => {
    const { data } = await axios.get(`${API_URL}/${movieId}`, {
      params: {
        api_key: myKey,
        append_to_response: "videos",
      },
    });
    setMovieVideos(data);
  };

  React.useEffect(() => {
    if (movieVideo !== null) {
      let trailer = movieVideo.videos.results.find((vid) => {
        if (
          vid.official &&
          (vid.type === "Trailer" ||
            vid.type === "Teaser" ||
            vid.type === "Teaser Trailer") &&
          (vid.name === "Official Trailer" ||
            vid.name === "Official Teaser" ||
            vid.name === "Official Teaser Trailer")
        ) {
          return vid;
        } else {
          return "";
        }
      });

      trailer =
        trailer !== undefined
          ? trailer
          : movieVideo.videos.results.length !== 0
          ? movieVideo.videos.results[movieVideo.videos.results.length - 1]
          : "";
      setTrailerKey(trailer === undefined ? "" : trailer.key);
    }
  }, [movieVideo]);

  return (
    <>
      <div className="movieCardMainContainer">
        <img
          src={posterImg}
          alt={movieTitle}
          className="posterCard"
          onClick={handleOpen}
        />
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className='movieModalBox'>
            <YouTube
              videoId={trailerKey}
              id="movieYoutubePlayer"
              className="youtubePlayer"
              opts={{ playerVars: { autoplay: 1 } }}
              style={{ background: '#000'}}
            />

            <div style={{padding: '0 12px', paddingBottom: '20px'}}>
              <h2>{movieTitle}</h2>
              <p>Release Date: {releaseDate}</p>
              <h2>Overview</h2>
              <p>{movieOverview}</p>
            </div>

          </Box>
        </Modal>
      </div>
    </>
  );
}
